import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// SEO: one preferred domain. The apex (https://leadxkids.com) is canonical in
// every canonical tag, the sitemap and llms files, so the www host must issue a
// permanent, path-preserving 301 instead of serving duplicate content.
const canonicalHostMiddleware = createMiddleware().server(async ({ next, request }) => {
  try {
    const url = new URL(request.url);
    if (url.hostname === "www.leadxkids.com") {
      url.protocol = "https:";
      url.hostname = "leadxkids.com";
      url.port = "";
      return new Response(null, {
        status: 301,
        headers: { location: url.toString(), "cache-control": "public, max-age=3600" },
      });
    }
  } catch {
    // Malformed URL: fall through to normal handling.
  }
  return await next();
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  requestMiddleware: [canonicalHostMiddleware, errorMiddleware, csrfMiddleware],
  functionMiddleware: [attachSupabaseAuth],
}));

